import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fi-service-error-page',
  templateUrl: './service-error-page.component.html',
  styleUrls: ['./service-error-page.component.scss'],
})
export class ServiceErrorPageComponent {}
